var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminTableOfContentsDrawer',{attrs:{"value":_vm.isShopSettingsNavbarOpen,"sections":_vm.getVisibleSettings},on:{"input":function($event){_vm.isShopSettingsNavbarOpen = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }